import { CrownIcon } from 'lucide-react';

interface ClubTabItemProps {
  onClick: () => void;
  isActive?: boolean;
}

/** Aba "Clube pratiGO" da barra inferior (só aparece com o programa ativo). */
export function ClubTabItem({ onClick, isActive = false }: ClubTabItemProps) {
  return (
    <button
      type="button"
      data-testid="club-tab"
      aria-label="Clube pratiGO"
      className="flex h-16 flex-col items-center justify-center space-y-2.5 py-2"
      onClick={onClick}
    >
      <CrownIcon
        className={isActive ? 'size-[26px] text-primary' : 'size-[26px] text-night'}
        strokeWidth={1.5}
      />
      <span className="whitespace-nowrap text-[11px] leading-none text-night">Clube pratiGO</span>
    </button>
  );
}
